import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import { useCallback } from 'react';
import { thunkCloseCurrentMessageBox } from '../../redux/actions/messageBoxesActions';
import { useAppDispatch } from '../../redux/store';
const BUTTON_CSS = css `
  padding: 2px 10px;
`;
export const HtmlAreaButton = ({ label, onClick }) => {
    const dispatch = useAppDispatch();
    const handleAllOnClick = useCallback(() => {
        dispatch(thunkCloseCurrentMessageBox()); // the HTML area containing the button may be in a message box, so close the current one (if any)
        onClick();
    }, [dispatch, onClick]);
    return (_jsx(Button, { css: BUTTON_CSS, onClick: handleAllOnClick, size: 'small', variant: 'outlined', color: 'primary', children: label }));
};
